module.exports = __webpack_public_path__ + "img/IMG_1444_L_Black_MockedUp.31c93138.jpg";